var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.540428 8.27184C-0.206023 8.59818 -0.175056 9.07614 0.607525 9.33421L2.92623 10.0987C3.70946 10.3579 4.89462 10.2165 5.55849 9.78474L15.6275 3.16754C16.2895 2.73367 16.3604 2.79765 15.7856 3.31055L7.82559 10.4106C7.24882 10.9218 7.41914 11.5498 8.20494 11.803L8.47656 11.8912C9.26236 12.1444 10.543 12.5697 11.3237 12.8342L13.8953 13.7068C14.6766 13.9713 15.5114 13.6595 15.7333 12.9821L19.6527 0.976678C19.874 0.299259 19.4443 0.0116244 18.6978 0.337431L0.540428 8.27184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.2e32f77ec1f6282d08758793204cfed4.svg";
export { ForwardRef as ReactComponent };